export default __webpack_public_path__ + "static/media/Quiken_ubicacion-48.fc0c7212.svg";